import config from 'config';

export const getUrlForMediaImage = imageUrl => {
  return `${config.mediaUrl}${imageUrl}`;
};
